import { getCookieByName } from '@/utils/cookie';

export function getSessionHeaders() {
  const sessionId = getCookieByName('stilingue-session-id');
  return sessionId ? { 'stilingue-session-id': sessionId } : {};
}

export function injectSessionIdHeader(api) {
  if (!api || typeof api.use !== 'function') return api;

  const apiDefaults = typeof api.getDefaults === 'function' ? api.getDefaults() : {};
  const existingRequestInterceptor = apiDefaults.interceptors && apiDefaults.interceptors.request;
  api.use({
    interceptors: {
      request: config => {
        const requestConfig = existingRequestInterceptor
          ? existingRequestInterceptor(config)
          : config;
        return {
          ...requestConfig,
          headers: {
            ...(requestConfig.headers || {}),
            ...getSessionHeaders(),
          },
        };
      },
    },
  });
  return api;
}
